/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import Select, { components } from 'react-select';
import { FormHelperText, Typography, FormControl } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
const ReactSelect = (props) => {
  const [isClearable, setIsClearable] = useState(false);
  const [isSearchable, setIsSearchable] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isRtl, setIsRtl] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');

  const {
    name,
    value,
    label,
    customClasses,
    disabled,
    required,
    placeholder,
    options,
    variant = 'outlined',
    error = null,
    onChange,
    open,
    isReturn = false,
    id,
    labelClass,
    isNoSeperator,
    ...others
  } = props;

  const transformedOptions = options?.map(option => ({
    label: option.title,
    value: option.value,
  })) || [];

  const customStyles = {
    singleValue: (provided) => ({
      ...provided,
      color: transformedOptions.length === 1 ? 'hsl(0, 0%, 50%)' : '#000',
    }),
    control: (provided) => ({
      ...provided,
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0 12px',
      borderColor: '#B72755',
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: 0,
      height: "36px",
    }),
    input: (provided) => ({
      ...provided,
      textAlign: 'center',
      border: 'none',
      boxShadow: 'none',
      padding: 0,
      margin: 0,
      position: 'relative',
      height: '38px'
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused
        ? 'rgba(0, 0, 0, 0.04)'
        : state.isSelected
          ? 'rgba(0, 0, 0, 0.08)'
          : null,
      color: 'black',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: 4,
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
  };

  useEffect(() => {
    if (open) {
      setIsOpen(true);
      setSelectedOption(transformedOptions[transformedOptions.length - 1]);
    }
    if (open === undefined && value) {
      const matchedOption = transformedOptions.find(option => option.value === value);
      if (matchedOption) setSelectedOption(matchedOption);
    }
  }, [value]);

  const handleCustomChange = (e) => {
    setSelectedOption(e);
    const event = {
      target: {
        name,
        value: e ? e.value : '',
      },
    };
    onChange(event);
  };
  const DropdownIndicator = (property) => (
    <components.DropdownIndicator {...property}>
      <ArrowDropDownIcon style={{ color: '#B72755', fontSize: '1.2857142857142856rem' }} />
    </components.DropdownIndicator>
  );
  return (
    <FormControl variant={variant} className="form-control react-select" error={!!error}>
      {label && (
        <Typography
          component="p"
          className={`${required ? 'inputLabel required' : 'inputLabel'} ${labelClass || ''}`}
        >
          {label}
        </Typography>
      )}
      <Select
        menuIsOpen={isOpen}
        onMenuOpen={() => setIsOpen(true)}
        onMenuClose={() => setIsOpen(false)}
        className={`custom-select ${customClasses || ''}`}
        classNamePrefix="select"
        isDisabled={disabled}
        isLoading={isLoading}
        isClearable={isClearable}
        isRtl={isRtl}
        onChange={handleCustomChange}
        isSearchable={isSearchable}
        name={name}
        options={transformedOptions}
        placeholder={placeholder}
        value={selectedOption}
        styles={customStyles}
        id={id}
        components={{ DropdownIndicator }}
        {...others}
      />
      <FormHelperText>{error && error}</FormHelperText>
    </FormControl>
  );
};

export default ReactSelect;
